"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOverlayZIndex = exports.useOverlayController = exports.OverlayControllerProvider = exports.OverlayContext = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
/**
 * @internal
 */
exports.OverlayContext = react_1.createContext(undefined);
exports.OverlayContext.displayName = "OverlayContext";
/**
 * Component for injecting {@link OverlayController} into all components in the application.
 *
 * @internal
 */
exports.OverlayControllerProvider = function (_a) {
    var children = _a.children, overlayController = _a.overlayController;
    return react_1.default.createElement(exports.OverlayContext.Provider, { value: overlayController }, children);
};
/**
 * Hook to get current instance of the {@link OverlayController}
 *
 * @returns an instance of the {@link OverlayController}
 *
 * @internal
 */
exports.useOverlayController = function () {
    return react_1.useContext(exports.OverlayContext);
};
/**
 * Hook to get the css `z-index` property for given overlay.
 *
 * @param uuid - uuid of the overlay.
 *
 * @returns - `z-index` for given overlay.
 *
 * @internal
 */
exports.useOverlayZIndex = function (uuid) {
    var overlayController = react_1.useContext(exports.OverlayContext);
    return overlayController.getZIndex(uuid);
};
//# sourceMappingURL=OverlayContext.js.map